export const getPdfPageLink = (url, page) => {
    if (!url || !page) return '';

    let targetPage = parseInt(page);

    // Logic: Starting from tert21.pdf, add +2 to the page number
    // Extract the number from "tert69.pdf"
    const match = url.match(/tert(\d+)/i);
    if (match) {
        const issueNumber = parseInt(match[1]);
        if (issueNumber >= 21) {
            targetPage += 2;
        }
    }

    return `/journals/${url}#page=${targetPage}`;
};
